<template>
  <p class="typewriter-text">
    <template v-for="(letter) in partialText">{{ letter }}</template>
  </p>
</template>

<script>
export default {
  name: "VueTypewriter",
  props: {
    text: {type: String, required: true},
  },
  data() {
    return {
      partialText: [],
      index: 0,
      interval: null,
    }
  },
  created() {
    this.interval = setInterval(() => {
      if (this.index >= this.text.length) {
        clearInterval(this.interval);
        this.interval = null;
      }
      let letter = this.text[this.index];
      this.index++;
      this.partialText.push(letter);
    }, 50);
  }
}
</script>

<style scoped>

</style>